import type { FileIconProps } from './FileIcon';

function FileAudioIcon({ extension, color, size = 28, ...props }: FileIconProps) {
  return (
    <svg width={size} height={size * 1.25} viewBox='0 0 28 36' fill={color} {...props}>
      <g clipPath='url(#clip0_407_6041)'>
        <path d='M4 35.5H24C26.2091 35.5 28 33.7091 28 31.5V10.5V4.5C28 2.29086 26.2091 0.5 24 0.5H18H4C1.79086 0.5 0 2.29086 0 4.5V31.5C0 33.7091 1.79086 35.5 4 35.5Z' />
        <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
          {extension?.toUpperCase()}
        </text>
        <path
          opacity='0.4'
          d='M8.66663 10.1667L1.99996 15.5001H-3.33337V23.5001H1.99996L8.66663 28.8334V10.1667Z'
          fill='url(#paint0_linear_407_6041)'
        />
        <path
          opacity='0.4'
          d='M19.4266 10.0732C21.9262 12.5736 23.3305 15.9644 23.3305 19.4999C23.3305 23.0354 21.9262 26.4262 19.4266 28.9266M14.72 14.7799C15.9698 16.0301 16.6719 17.7255 16.6719 19.4932C16.6719 21.261 15.9698 22.9564 14.72 24.2066'
          stroke='url(#paint1_linear_407_6041)'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_407_6041'
          x1='2.66663'
          y1='10.1667'
          x2='2.66663'
          y2='28.8334'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_407_6041'
          x1='19.0252'
          y1='10.0732'
          x2='19.0252'
          y2='28.9266'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_407_6041'>
          <path
            d='M0 4.5C0 2.29086 1.79086 0.5 4 0.5H24C26.2091 0.5 28 2.29086 28 4.5V31.5C28 33.7091 26.2091 35.5 24 35.5H4C1.79086 35.5 0 33.7091 0 31.5V4.5Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FileAudioIcon;
